// Central content file — update text, numbers, contacts and imagery here.

export const BRAND = {
    name: "Kavraj Spaces",
    tagline: "One Partner. Four Capabilities.",
};

export const NAV_LINKS = [
    { name: "Home", path: "/", testid: "nav-link-home" },
    { name: "About", path: "/about", testid: "nav-link-about" },
    { name: "Real Estate", path: "/real-estate", testid: "nav-link-real-estate" },
    { name: "Interiors", path: "/interiors", testid: "nav-link-interiors" },
    { name: "Furniture", path: "/furniture", testid: "nav-link-furniture" },
    { name: "Air Conditioning", path: "/air-conditioning", testid: "nav-link-air-conditioning" },
    { name: "Experience", path: "/experience", testid: "nav-link-experience" },
    { name: "Contact", path: "/contact", testid: "nav-link-contact" },
];

export const CONTACTS = [
    {
        id: "yuvraj",
        name: "Yuvraj Singh Marwaha",
        role: "Co-Founder",
        focus: "Real estate advisory & leasing",
        phoneDisplay: "+91 97173 72027",
        tel: "tel:+919717372027",
        whatsapp:
            "https://wa.me/919717372027?text=Hello%20Yuvraj%2C%20I%20would%20like%20to%20discuss%20a%20requirement%20with%20Kavraj%20Spaces.",
    },
    {
        id: "kanav",
        name: "Kanav Bakshi",
        role: "Co-Founder",
        focus: "Interiors & furniture",
        phoneDisplay: "+91 98111 67816",
        tel: "tel:+919811167816",
        whatsapp:
            "https://wa.me/919811167816?text=Hello%20Kanav%2C%20I%20would%20like%20to%20discuss%20a%20requirement%20with%20Kavraj%20Spaces.",
    },
    {
        id: "viraj",
        name: "Viraj Singh Sareen",
        role: "Co-Founder",
        focus: "Air Conditioning Solutions and Construction",
        phoneDisplay: "+91 99532 54488",
        tel: "tel:+919953254488",
        whatsapp:
            "https://wa.me/919953254488?text=Hello%20Viraj%2C%20I%20would%20like%20to%20discuss%20a%20requirement%20with%20Kavraj%20Spaces.",
    },
];

export const LOCATIONS = [
    "Anand Niketan, New Delhi",
    "Jail Road, New Delhi",
    "Kirti Nagar, New Delhi",
];

export const EMAIL = "enquiries@kavrajspaces.com";

export const IMAGES = {
    hero: {
        url: "https://images.pexels.com/photos/13722826/pexels-photo-13722826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        alt: "Warm, elegantly lit premium interior with crafted furniture (representational image)",
    },
    realEstate: {
        url: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBsdXh1cnklMjBhcmNoaXRlY3R1cmUlMjBlc3RhdGUlMjBleHRlcmlvcnxlbnwwfHx8fDE3OTIzMjU3OTJ8MA&ixlib=rb-4.1.0&q=85",
        alt: "Premium modern residential architecture at dusk (representational image)",
    },
    interiors: {
        url: "/images/interiors-page.jpg",
        alt: "Warm neutral luxury living room with marble media wall and lit display shelving",
    },
    furniture: {
        url: "/images/furniture-page.jpg",
        alt: "Craftsman hand-finishing a fluted hardwood sideboard in the Kavraj Atelier workshop",
    },
    studio: {
        url: "https://images.pexels.com/photos/19577838/pexels-photo-19577838.jpeg?auto=compress&cs=tinysrgb&w=1400",
        alt: "Architectural material library with walnut veneers, bronze plates and stone samples in a warm atelier (representational image)",
    },
    acCassette: {
        url: "https://images.unsplash.com/photo-1746439307632-cba0f8effbed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBsdXh1cnklMjBsaXZpbmclMjByb29tJTIwYWlyJTIwY29uZGl0aW9uZXIlMjBkdWN0JTIwY2VpbGluZ3xlbnwwfHx8fDE3OTI2MDk4MDJ8MA&ixlib=rb-4.1.0&q=85&w=1400",
        alt: "Refined living room with concealed ceiling air-conditioning and warm cove lighting (representational image)",
    },
    acUnit: {
        url: "https://images.unsplash.com/photo-1759262151046-b91fa96e4006?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NzA2ODl8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBtb2Rlcm4lMjBpbnRlcmlvciUyMGNlaWxpbmclMjBhaXIlMjBjb25kaXRpb25lciUyMHZlbnQlMjBjbGltYXRlfGVufDB8fHx8MTc5MjYwOTc5NHww&ixlib=rb-4.1.0&q=85&w=1400",
        alt: "Sleek indoor air-conditioning unit in a warm modern interior (representational image)",
    },
};

export const SERVICES = [
    {
        id: "real-estate",
        title: "Real Estate Advisory & Leasing",
        summary:
            "Residential and commercial property advisory across Delhi, with particular expertise in South Delhi — from HNI and UHNI mandates to pre-rented investments, farmhouses and diplomatic leasing.",
        link: "/real-estate",
        image: {
            url: "/images/real-estate-card.jpg",
            alt: "Premium modern home entrance at twilight with warm architectural lighting (representational image)",
        },
    },
    {
        id: "interiors",
        title: "Turnkey Interior Design",
        summary:
            "Design and execution delivered end to end — residences in Delhi and Gurgaon, corporate offices, hospitality, franchises, hospitals, government departments and institutions.",
        link: "/interiors",
        image: {
            url: "/images/interiors-card.jpg",
            alt: "Warm modern luxury living room with bronze accents and elegant furnishings (representational image)",
        },
    },
    {
        id: "furniture",
        title: "Bespoke Furniture & Manufacturing",
        summary:
            "An in-house manufacturing division crafting bespoke residential furniture and supplying projects for homes, offices, franchises, hospitals and institutions.",
        link: "/furniture",
        image: {
            url: "https://images.pexels.com/photos/5974327/pexels-photo-5974327.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
            alt: "Craftsman shaping solid wood joinery in a workshop (representational image)",
        },
    },
    {
        id: "air-conditioning",
        title: "Air Conditioning — Breeze Master",
        summary:
            "Wholesaler and retailer since 1970 — authorised for leading brands, supplying split, cassette, ductable and VRV/VRF systems to homes and businesses.",
        link: "/air-conditioning",
        image: IMAGES.acUnit,
    },
];

export const STATS = [
    { value: "100+", label: "Clients served by the real estate practice" },
    { value: "₹600 Cr+", label: "Property inventory advised and sold" },
    { value: "60", label: "Years of combined legacy across these sectors" },
];

export const EXPERIENCE_STATS = [
    { value: "100+", label: "Clients served" },
    { value: "₹600 Cr+", label: "Property inventory advised and sold" },
    { value: "60", label: "Years of combined legacy across these sectors" },
];

export const HOME_STATS = [
    { value: "100+", label: "Clients served" },
    { value: "₹600 Cr+", label: "Property inventory advised and sold" },
    { value: "60", label: "Years of combined legacy across these sectors" },
];

export const JOURNEY_STEPS = [
    {
        number: "01",
        title: "Identify",
        text: "The right property — sourced, evaluated and negotiated with discretion.",
    },
    {
        number: "02",
        title: "Design",
        text: "Turnkey interiors, planned and executed by a single accountable team.",
    },
    {
        number: "03",
        title: "Furnish",
        text: "Bespoke furniture from our own manufacturing division, made for the space.",
    },
];

export const REAL_ESTATE_OFFERINGS = [
    {
        title: "Residential & Commercial Advisory",
        text: "Buying, selling and portfolio guidance across Delhi, led by deep South Delhi market knowledge.",
    },
    {
        title: "HNI & UHNI Advisory",
        text: "Confidential, high-value mandates handled with discretion and direct founder involvement.",
    },
    {
        title: "Pre-Rented Commercial Investments",
        text: "Income-generating commercial assets, assessed for yield, tenant quality and long-term value.",
    },
    {
        title: "Commercial Renting & Leasing",
        text: "Offices, retail and commercial spaces — for occupiers and for landlords.",
    },
    {
        title: "Farmhouses",
        text: "Farmhouse estates around Delhi, from identification through acquisition.",
    },
    {
        title: "Property Liaisoning",
        text: "Liaison and coordination for property matters — documentation, approvals and stakeholder follow-through handled on your behalf.",
    },
    {
        title: "Builder Collaborations",
        text: "Collaboration opportunities with leading A-grade builders across the city.",
    },
    {
        title: "Embassy & Consulate Leasing",
        text: "Residences and premises aligned to diplomatic requirements and protocols.",
    },
    {
        title: "Institutional Sourcing",
        text: "Guest houses and institutional properties sourced to specification.",
    },
];

export const INTERIOR_SECTORS = [
    {
        title: "Residential",
        text: "Homes across Delhi and Gurgaon — apartments, builder floors, villas and farmhouses, delivered turnkey.",
    },
    {
        title: "Corporate Offices",
        text: "Workplaces designed and executed for how teams actually work.",
    },
    {
        title: "Hospitality & Restaurant",
        text: "Hotels, restaurants and dining spaces built for durability and warmth.",
    },
    {
        title: "Brand Franchises",
        text: "Repeatable, brand-true fit-outs delivered across 100+ franchise locations.",
    },
    {
        title: "Healthcare",
        text: "Hospitals and clinical spaces planned around compliance, hygiene and calm.",
    },
    {
        title: "Government & Institutional",
        text: "Departments and institutions served with process-driven, documented execution.",
    },
];

export const FURNITURE_PILLARS = [
    {
        title: "Bespoke Residential Furniture",
        text: "Made-to-measure pieces for homes — designed with the client, built to last generations.",
    },
    {
        title: "In-House Manufacturing",
        text: "Our own manufacturing division controls material, joinery and finish — nothing outsourced in quality.",
    },
    {
        title: "Project Supply",
        text: "Volume furniture supply for offices, corporates, brand franchises, restaurants, hospitals and institutions, delivered to schedule.",
    },
];

export const BREEZE_MASTER = {
    name: "Breeze Master",
    badge: "Wholesaler & Retailer Since 1970",
    intro: "Breeze Master is a trusted name in climate control solutions and an authorised distributor and retailer for leading air conditioning brands. We supply high-quality air-conditioning systems and components to residential, commercial and industrial clients, serving homeowners, businesses, HVAC contractors and resellers.",
    brands: [
        { name: "Napoleon", text: "Heavy duty high-performance machines." },
        { name: "Mitsubishi Electric", text: "Advanced technology for reliable, sustainable comfort." },
        { name: "Mitsubishi Heavy Duty", text: "High-performance systems designed for durability and powerful cooling." },
        { name: "Panasonic", text: "Intelligent features and eco-conscious climate control." },
        { name: "OG Heavy Duty", text: "Rugged, dependable systems for demanding environments." },
    ],
    products: [
        { name: "Split AC", text: "Wall-mounted systems for rooms, homes and offices." },
        { name: "Cassette AC", text: "Ceiling-mounted units for even, unobtrusive cooling." },
        { name: "Ductable AC", text: "Central ducted systems for larger floors and spaces." },
        { name: "VRV / VRF Systems", text: "Variable-refrigerant systems for multi-zone buildings." },
        { name: "Concealed Ducted AC", text: "Fully hidden systems for seamless interiors." },
    ],
    offerings: [
        "Wholesale supply for HVAC contractors and resellers",
        "Retail sales for homeowners and businesses",
        "Product recommendations based on each client's requirements",
        "Competitive pricing and responsive turnaround",
        "Reliable stock availability through a dependable supply chain",
        "Expert product guidance and installation coordination",
        "Post-sale support and warranty guidance",
    ],
    mission:
        "To deliver high-quality, energy-efficient climate solutions that bring comfort, reliability and value, while building long-term partnerships with contractors, installers and homeowners.",
};

export const CLIENT_LOGOS = [
    { id: "gmr", name: "GMR", src: "/logos/gmr.png", alt: "GMR logo" },
    {
        id: "delhi-airport",
        name: "Delhi Indira Gandhi International Airport",
        src: "/logos/delhi-airport.png",
        alt: "Delhi Indira Gandhi International Airport logo",
    },
    { id: "adani", name: "Adani", src: "/logos/adani.png", alt: "Adani logo" },
    { id: "sbi", name: "State Bank of India", src: "/logos/sbi.png", alt: "State Bank of India logo" },
    {
        id: "the-lalit",
        name: "The Lalit",
        src: "/logos/the-lalit.png",
        alt: "The Lalit Hotels logo",
        className: "h-16 sm:h-20",
    },
    { id: "elan", name: "Elan", src: "/logos/elan.png", alt: "Elan logo" },
    {
        id: "kenangan-coffee",
        name: "Kenangan Coffee",
        src: "/logos/kenangan-coffee.png",
        alt: "Kenangan Coffee logo",
    },
    {
        id: "delhi-university",
        name: "University of Delhi",
        src: "/logos/delhi-university.png",
        alt: "University of Delhi crest",
        className: "h-16 sm:h-20",
    },
    {
        id: "vietnam-embassy",
        name: "Embassy of Viet Nam in India",
        src: "/logos/vietnam-embassy.png",
        alt: "Embassy of Viet Nam in India emblem",
        className: "h-16 sm:h-20",
    },
    {
        id: "british-high-commission",
        name: "British High Commission New Delhi",
        src: "/logos/british-high-commission.png",
        alt: "Flags of India and the United Kingdom",
        className: "h-14 sm:h-16",
        caption: "British High Commission New Delhi",
    },
    {
        id: "dps",
        name: "Delhi Public School",
        src: "/logos/dps.png",
        alt: "Delhi Public School crest",
        className: "h-16 sm:h-20",
    },
    {
        id: "aicaa",
        name: "AICAA — All India Chartered Accountants' Association",
        src: "/logos/aicaa.png",
        alt: "All India Chartered Accountants' Association logo",
        className: "h-14 sm:h-16",
    },
    {
        id: "read-india",
        name: "READ India",
        src: "/logos/read-india.png",
        alt: "READ India logo",
    },
    {
        id: "masters-union",
        name: "Masters' Union",
        src: "/logos/masters-union.png",
        alt: "Masters' Union logo",
        className: "h-12 sm:h-14",
    },
    {
        id: "indian-air-force",
        name: "Indian Air Force",
        src: "/logos/indian-air-force.png",
        alt: "Indian Air Force crest",
        className: "h-16 sm:h-20",
    },
];

export const REAL_ESTATE_GALLERY = [
    {
        src: "/images/re-carousel/exterior.jpg",
        alt: "Premium builder-floor residence exterior with warm wood detailing",
    },
    {
        src: "/images/re-carousel/dining.jpg",
        alt: "Open-plan living and dining space with marble flooring and pendant lighting",
    },
    {
        src: "/images/re-carousel/bedroom.jpg",
        alt: "Warm minimalist bedroom with panelled headboard wall and balcony view",
    },
    {
        src: "/images/re-carousel/kitchen.jpg",
        alt: "Island kitchen with pendant lighting and garden view",
    },
    {
        src: "/images/re-carousel/bathroom.jpg",
        alt: "Designer bathroom in dark stone with glass shower enclosure",
    },
];

export const EMBASSIES = ["United Kingdom", "Vietnam", "Canada", "Hungary", "Sudan"];

export const ENQUIRY_SERVICES = [
    "Real Estate Advisory",
    "Interior Design",
    "Bespoke Furniture",
    "Air Conditioning (Breeze Master)",
    "Complete / Multiple Services",
    "Other",
];
